import React from 'react';
import { ClassicOnboardingLayout } from './classic/classic.onboarding.layout';
import { useAppState } from '../../overmind';
import { hasRequiredFeatureFlag } from '../../library/helpers/feature-flags';
import { FeatureFlagType } from '../../enums/feature-flag-type';
import { FreemiumOnboardingLayout } from '../freemium-feature/freemium-onboarding/freemium.onboarding.layout';
import { ErrorPage } from '../error/error.page';

export function OnboardingPage(): JSX.Element {
  const { companyVariables } = useAppState();
  if (hasRequiredFeatureFlag([FeatureFlagType.FreemiumSignup], companyVariables.featureFlags)) {
    return <FreemiumOnboardingLayout></FreemiumOnboardingLayout>;
  } else if (hasRequiredFeatureFlag([FeatureFlagType.ClassicFeatures], companyVariables.featureFlags)) {
    return <ClassicOnboardingLayout></ClassicOnboardingLayout>;
  }
  return <ErrorPage />;
}
